import angular from 'angular'
import gql from 'graphql-tag'

class Faturamento {
  static get $inject() {
    return ['gql']
  }

  constructor(gql) {
    this.gql = gql
  }

  async listProdutos() {
    const query = gql`
      query FaturamentoProdutos {
        faturamentoProdutos {
          id
          nome
          sigla
          descricao
          grupo
        }
      }
    `

    const { faturamentoProdutos } = await this.gql.query(query)

    return faturamentoProdutos
  }
}

angular.module('eficienciaFiscalModule').service('Faturamento', Faturamento)
